import { Box, Typography, Button, Card, CardContent, Grid } from '@mui/material'
import { Add, Dashboard, Visibility } from '@mui/icons-material'

import { EmptyState } from '@/components/shared/EmptyState'

export function DashboardsPage() {
    // Backend dashboards API is not yet fully implemented — show feature preview
    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography variant="h5">Custom Dashboards</Typography>
                <Button variant="contained" startIcon={<Add />} disabled>
                    New Dashboard
                </Button>
            </Box>

            <EmptyState
                icon={<Dashboard />}
                title="No custom dashboards yet"
                description="Create custom dashboards with drag-and-drop widgets to visualize your data exactly how you want."
            />

            {/* Feature Preview */}
            <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                Coming Soon
            </Typography>
            <Grid container spacing={2}>
                {[
                    {
                        title: 'Drag & Drop Builder',
                        desc: 'Build custom layouts with line charts, bar charts, tables, and metric cards.',
                    },
                    {
                        title: 'Embeddable Dashboards',
                        desc: 'Share dashboards externally with secure embed tokens.',
                    },
                    {
                        title: 'Scheduled Reports',
                        desc: 'Auto-generate PDF/email reports on a custom schedule.',
                    },
                ].map(feature => (
                    <Grid key={feature.title} size={{ xs: 12, sm: 4 }}>
                        <Card variant="outlined" sx={{ opacity: 0.7 }}>
                            <CardContent>
                                <Visibility color="primary" sx={{ mb: 1 }} />
                                <Typography variant="subtitle1" fontWeight={600}>
                                    {feature.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {feature.desc}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}
